import { withSvgIcon } from './withSvgIcon';

export const UpperTriangle = withSvgIcon(
  <path
    d="M0.785511 11.5L7.33807 0.681818L13.8956 11.5H0.785511Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 14 12' },
);
